<template lang="pug">
    v-row(align='center' justify="center" v-if="validIncomingPhoneNumber")

        v-snackbar(
            v-model='snackbar.show'
            :color='snackbar.color'
            :timeout="snackbar.timeout"
            top
        )
            | {{ snackbar.text }}
            v-btn(dark text @click='snackbar.show = false')
                | Close

        v-snackbar(
            v-model="complianceSnackbarShow"
            color="warning"
            :timeout="10000"
            top
            multi-line
        )
            div.d-flex.flex-column.align-center
                ul.mb-0.pl-4.text-left
                    li(v-for="warning in complianceWarnings" :key="warning") {{ warning }}
                v-btn(dark text @click="complianceSnackbarShow = false")
                    | Dismiss

        DialPad(
            v-if="dialPadDialog"
            :call-id="callId"
            :close-dial-pad="closeDialPad"
            :send-digit="sendDigit"
        )

        InstantVoicemailDialog(
            v-if="instantVoicemailDialog"
            :call="call"
            :close-instant-voicemail="closeInstantVoicemail"
        )

        TransferDialog(
            v-if="transferDialog"
            :call-id="callId"
            communication-provider="twilio"
            :complete-attempt-for-internal-transfer="completeAttemptForInternalTransfer"
            :current-agent="currentAgent"
            :destination="transferDestination"
            :destination-id="transferDestinationID"
            :end-call="endCall"
            :exit-transfer-dialog="exitTransferDialog"
            :is-muted="isMuted"
            :is-twilio="true"
            :location="transferLocation"
            :mute-unmute-call="muteUnmuteCall"
            :mute-btn-color="muteBtnColor"
            :on-hold="onHold"
            :toggle-on-hold="toggleOnHold"
            :toggle-is-muted="toggleIsMuted"
            :send-digit="sendDigit"
            :show-snackbar="showSnackbar"
            :transfer-to-extension="transferToExtension"
            :transfer-to-number="transferToNumber"
            :type="transferType"
            :voice-mail-recording="voiceMailRecording"
        )

        v-col.text-center.padding-xs(v-if="renderStartActions")
            ManualMode(
                v-if="renderManualMode"
                :enter-manual-mode="enterManualMode"
                :exit-manual-mode="exitManualMode"
                :has-logged-in-queues="hasLoggedInQueues"
                :is-manual-mode="isManualMode"
                :organization-users="organizationUsers"
                :render-enroll-as-eligible="true"
                :valid-campaign-customer-active-id="validCurrentCampaignCustomer"
            )

            v-btn-toggle.my-1
                v-btn(
                    @click="startNextDial();"
                    color='success'
                    :disabled='isStartNextDialButtonDisabled'
                    :loading='initializingPhoneCall'
                    small
                )
                    | Start Next Dial

                v-menu(
                    v-if="validAvailableDialPhoneNumbers"
                    bottom
                    close-on-click
                    transition='scale-transition'
                    :disabled='isStartNextDialButtonDisabled || initializingPhoneCall || !validAvailableDialPhoneNumbers'
                )
                    template(v-slot:activator='{ on, attrs }')
                        v-btn(
                            light
                            small
                            v-bind='attrs'
                            v-on='on'
                        )
                            v-icon(v-if="validAvailableDialPhoneNumbers") mdi-menu-down
                            v-icon(v-else) mdi-minus
                    v-list

                        v-list-item(
                            v-for='(pn, idx) in availableDialPhoneNumbers'
                            :key='idx'
                            ripple
                            :disabled="!phoneAllowed(pn)"
                            @click='startNextDial(pn.customer_phone_number_id);'
                        )
                            v-list-item-icon
                                v-icon(v-if="!phoneAllowed(pn)" color="error") mdi-alert
                                v-icon(v-if="nextAttemptableID === pn.customer_phone_number_id") mdi-chevron-right
                            v-list-item-content
                                v-list-item-title {{ pn.phone_number_phone_number | tel }}
                                v-list-item-subtitle {{ pn.phone_number_type | titleize }}

        v-col.text-center.padding-xs(v-if="renderPhoneControls")
            v-simple-table(dense)
                template(v-slot:default)
                    tbody
                        tr
                            td
                                v-btn-toggle(rounded dense background-color="warning")
                                    v-tooltip(bottom)
                                        template(v-slot:activator='{ on, attrs }')
                                            v-btn(v-bind='attrs' v-on='on' @click="muteUnmuteCall();" :color="muteBtnColor" :disabled="onHold")
                                                v-icon(dark) mdi-microphone-off
                                        span(v-if="!isMuted") Mute
                                        span(v-else) Unmute

                                    v-tooltip(bottom)
                                        template(v-slot:activator='{ on, attrs }')
                                            v-btn(:disabled="isSupervisor" v-bind='attrs' v-on='on' @click="holdUnholdCall();" :color="holdBtnColor")
                                                v-icon(dark v-if="!onHold") mdi-pause-octagon
                                                v-icon(dark v-else) mdi-play-circle
                                        span(v-if="!onHold") Place on Hold
                                        span(v-else) Return to Call

                                    v-tooltip(bottom)
                                        template(v-slot:activator='{ on, attrs }')
                                            v-btn(
                                                v-bind='attrs'
                                                v-on='on'
                                                ripple
                                                @click.stop="openDialPad();"
                                            )
                                                v-icon(dark) mdi-dialpad
                                        span Dial Pad

                                    v-tooltip(bottom v-if="instantVoiceMailEnabled")
                                        template(v-slot:activator='{ on, attrs }')
                                            v-btn(v-bind='attrs' v-on='on' @click="openInstantVoicemailDialog();")
                                                v-icon(dark) mdi-voicemail
                                        span Instant Voicemail

                                    v-tooltip(v-if="!isSupervisor" bottom)
                                        template(v-slot:activator='{ on, attrs }')
                                            v-btn(v-bind='attrs' v-on='on' @click="endCall();")
                                                v-icon(dark) mdi-phone-hangup
                                        span End Call
                                    v-tooltip(v-else)
                                        template(v-slot:activator='{ on, attrs }')
                                            v-btn(v-bind='attrs' v-on='on' @click="endCall();")
                                                v-icon(dark) mdi-account-multiple-remove
                                        span(v-if="isBarge") Leave Barge Session
                                        span(v-else-if="isListen") Leave Listen Session

                                    template(v-if="showTransferMenu")
                                        v-menu(
                                            bottom
                                            close-on-click
                                            transition="scale-transition"
                                            offset-y
                                        )
                                            template(v-slot:activator="{ on: menuOn, attrs: menuAttrs }")
                                                v-tooltip(bottom)
                                                    template(v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }")
                                                        v-btn(
                                                        v-bind="{ ...menuAttrs, ...tooltipAttrs }"
                                                        v-on="{ ...menuOn, ...tooltipOn }"
                                                        :disabled="isSupervisor"
                                                        )
                                                            v-icon(dark) mdi-phone-forward
                                                    span Transfer

                                            v-list
                                                template(v-if="allowedInternalBlindTransfersEnabled")
                                                    v-list-item(
                                                        ripple
                                                        @click.stop="openTransferDialog('user', 'internal', 'blind');"
                                                    )
                                                        v-list-item-icon
                                                            v-icon mdi-account-group
                                                        v-list-item-content
                                                            v-list-item-title Blind Transfer
                                                            v-list-item-subtitle Internal

                                                template(v-if="allowedExternalBlindTransfersEnabled")
                                                    v-list-item(
                                                        ripple
                                                        @click.stop="openTransferDialog('unknown', 'external', 'blind');"
                                                    )
                                                        v-list-item-icon
                                                            v-icon mdi-phone-forward
                                                        v-list-item-content
                                                            v-list-item-title Blind Transfer
                                                            v-list-item-subtitle External

                                                template(v-if="allowedExternalWarmTransfersEnabled")
                                                    v-list-item(
                                                        ripple
                                                        @click.stop="openTransferDialog('unknown', 'external', 'warm');"
                                                    )
                                                        v-list-item-icon
                                                            v-icon mdi-phone-forward
                                                        v-list-item-content
                                                            v-list-item-title Warm Transfer
                                                            v-list-item-subtitle External

                            td(v-if="recordEnabled")
                                v-tooltip(bottom)
                                    template(v-slot:activator='{ on, attrs }')
                                        v-btn(
                                            v-bind='attrs'
                                            v-on='on'
                                            @click="pauseResumeRecording();"
                                            :disabled="!validRecordingID"
                                            icon
                                            small
                                            :color="!isRecordingPaused ? 'red' : 'black'"
                                        )
                                            v-icon(dark v-if="!isRecordingPaused") mdi-stop
                                            v-icon(dark v-else) mdi-record-circle
                                    span(v-if="!isRecordingPaused") Pause Call Recording
                                    span(v-else) Resume Call Recording

        v-col.text-center.padding-xs(v-else-if="renderNextActions")
            v-btn.ma-2.btn-margin-xs(
                v-if="renderSaveStopButton"
                color='error'
                :x-small="selectedDispositionHasSmsMessageFollowUp"
                :small="!selectedDispositionHasSmsMessageFollowUp"
                @click="startSaveAndNext(saveAndStopAction);"
                :disabled="!isOkayToSaveAndNext"
            )
                div(v-if="selectedDispositionHasSmsMessageFollowUp")
                    | Save & Send SMS Follow Up
                    v-icon(small) mdi-arrow-right-thick
                    | Stop
                div(v-else)
                    | Save
                    v-icon(small) mdi-arrow-right-thick
                    | Stop

            v-btn.ma-2.btn-margin-xs(
                v-if="renderSaveContinueButton"
                color='success'
                :x-small="selectedDispositionHasSmsMessageFollowUp"
                :small="!selectedDispositionHasSmsMessageFollowUp"
                @click="startSaveAndNext('continue');"
                :disabled="!isOkayToSaveAndNext"
            )
                div(v-if="selectedDispositionHasSmsMessageFollowUp")
                    | Save & Send SMS Follow Up
                    v-icon(small) mdi-arrow-right-thick
                    | Survey
                div(v-else)
                    | Save
                    v-icon(small) mdi-arrow-right-thick
                    | Survey

            v-btn.ma-2.btn-margin-xs(
                v-else
                color='success'
                :x-small="selectedDispositionHasSmsMessageFollowUp"
                :small="!selectedDispositionHasSmsMessageFollowUp"
                @click="startSaveAndNext('continue_and_start');"
                :disabled="!isOkayToSaveAndNext"
            )
                div(v-if="selectedDispositionHasSmsMessageFollowUp")
                    | Save & Send SMS Follow Up
                    v-icon(small) mdi-arrow-right-thick
                    | Dial Next
                div(v-else)
                    | Save
                    v-icon(small) mdi-arrow-right-thick
                    | Dial Next

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState  from "@/store";
    import { Device, Call } from '@twilio/voice-sdk';
    import { getTwilioVoiceEdge } from '@/helpers/twilio_voice';

    // Components
    import DialPad from '@/components/communication_center/phone/dial_pad_dialog.vue';
    import InstantVoicemailDialog from '@/components/communication_center/phone/instant_voicemail_dialog.vue';
    import ManualMode from '@/components/communication_center/shared/manual_mode.vue';
    import TransferDialog from '@/components/communication_center/phone/transfer_dialog.vue';

    // Constants
    import { INBOUND_WRAP_UP, OUTBOUND_WRAP_UP } from '@/constants/agent_statuses';

    // Data
    import { CreateOutboundCall, CreateWebRtcSample, GenerateCapabilityToken, HandleAgentCallDisconnect, HoldCall, MuteCall, PauseRecording, ResumeRecording, SendDTMF, UnholdCall, UnmuteCall } from "@/data";

    // Helpers
    import { getBrowserInfo } from "@/helpers/browser";

    export default Vue.extend({
        data() {
            return {
                agentSoftphone: null,
                agentToken: null,
                availableDialPhoneNumbers: [],
                bus: VolieState.websocketClient().eventBus(),
                call: null,
                componentDestroyed: false,
                conference: null,
                connectAttempt: false,
                connectedCall: null,
                connection: null,
                device: null,
                dialPadDialog: false,
                complianceWarnings: [],
                complianceSnackbarShow: false,
                complianceSnackbarTimeoutId: null,
                disconnectedCallId: 0,
                disconnectedPhoneCall: false,
                initializingPhoneCall: false,
                instantVoicemailDialog: false,
                isRecordingPaused: false,
                isRunningAction: false,
                isMuted: false,
                isNonBrowserDevice: false,
                isOutbound: false,
                onHold: false,
                otherLegRecordEnabled: false,
                snackbar: {
                    color: null,
                    show: false,
                    text: null,
                    timeout: 2500,
                },
                status: null,
                transferDestination: null,
                transferDestinationID: null,
                transferDialog: false,
                transferLocation: null,
                transferToExtension: null,
                transferToNumber: null,
                transferType: null,

                // references for telemetry handlers & state
                _qualitySampleHandler: null as ((s: any) => void) | null,
                _telemetryCallRef: null as Call | null,
                _onCallAcceptHandler: null as (() => void) | null,
                _onCallDisconnectHandler: null as (() => void) | null,
                _onBeforeUnloadHandler: null as ((e: BeforeUnloadEvent) => void) | null,
                _retryPollID: null,
                _samplingPollID: null,
            }
        },
        methods: {
            buildAvailableDialPhoneNumbers() {

                // Reinit
                this.availableDialPhoneNumbers = [];

                // Verify
                if (!this.communicationManager || !(this.communicationManager?.customer_phone_numbers?.length > 0)) {
                    return;
                }

                // Loop through phone numbers and build array
                for (let i = 0; i < this.communicationManager.customer_phone_numbers.length; i++) {

                    // Init
                    const customerPN = this.communicationManager.customer_phone_numbers[i];
                    if (!customerPN || !(customerPN.customer_phone_number_id > 0)) {
                        continue;
                    }

                    // Push onto array
                    this.availableDialPhoneNumbers.push(customerPN);
                }

                this.continueSaveAndDialNextIfApplicable();
            },
            clearComplianceSnackbarTimeout() {
                if (this.complianceSnackbarTimeoutId !== null) {
                    clearTimeout(this.complianceSnackbarTimeoutId);
                    this.complianceSnackbarTimeoutId = null;
                }
            },
            closeDialPad() {
                this.dialPadDialog = false;
            },
            closeInstantVoicemail(snackbarColor, snackbarText) {
                this.instantVoicemailDialog = false;
                this.showSnackbar(snackbarColor, snackbarText);
            },
            async connectDeviceToCall() {

                if (this.isNonBrowserDevice) {
                    return;
                }

                // VE-10377: after an intentional hang-up, do not reconnect to the dead call.
                if (this.isDisconnectedCall()) {
                    return;
                }

                if (!this.call || !!this.connection) {
                    return;
                }

                // Verify device is ready
                if (!(this.status === "ready" && !!this.device)) {
                    return;
                }

                // Verify outbound call didn't error
                if (this.callFailed) {
                    return;
                }

                this.connectAttempt = true;

                // VE-10380: snapshot the call this connection owns so a lagging teardown attributes wrap up correctly.
                this.connectedCall = { ...this.call };

                try {
                    this.connection = await this.device.connect({
                        params: {
                            volieCallId: this.call.id,
                            volieAccountId: this.call.account_id,
                            volieBarge: this.isBarge,
                            volieListen: this.isListen,
                        },
                    });

                    this._attachCallTelemetryHandlers(this.connection);
                    this.ensureOverflowHidden();
                } catch (err) {
                    this.handleConnectFailure(err);
                }
            },
            connectFailureMessage(err) {
                const code = err?.code;
                const twilioMessage = err?.message;

                switch (code) {
                case 31402:
                    return "Microphone access was denied. Check browser permissions and your input device.";
                case 31009:
                    return "Unable to reach Twilio. Check your network or VPN connection.";
                case 31208:
                    return "Call connection timed out. Try again.";
                default:
                    return twilioMessage?.length > 0
                        ? twilioMessage
                        : "Phone connection failed. Try refreshing the page.";
                }
            },
            handleConnectFailure(err) {
                console.error("twilio device connect failed", err);

                this.connectAttempt = false;
                this.connection = null;
                this._stopStatMonitoring();

                const message = this.connectFailureMessage(err);
                this.showSnackbar("error", message);

                if (this.isOutbound) {
                    this.setCallFailed(true);
                    this.handleOutboundCallError(message);
                    return;
                }

                this.initializingPhoneCall = false;
                this.endCall();
            },
            continueForceStartNextDialIfApplicable() {
                if (this.forceStartNextDial !== true || this.isBlockedFromDialOrReconnectDuringWrapUp()) {
                    return false;
                }

                let started = false;
                if (this.validVoiceMailRecording) {
                    started = this.startNextDial(null, this.voiceMailRecording?.voice_mail_recording_id) === true;
                } else if (this.validPendingSavedPlaceCall) {
                    started = this.startNextDial(null, null, this.pendingSavedPlaceCall.scheduled_communication_id) === true;
                } else if (this.forceValidatedOutboundNumber) {
                    started = this.startNextDial(null, null, null, this.forceValidatedOutboundNumber) === true;
                }

                if (started && typeof this.clearDialIntent === "function") {
                    this.clearDialIntent();
                }
                return started;
            },
            continueSaveAndDialNextIfApplicable() {

                // Action must be continue and start
                if (this.saveAndNextAction !== "continue_and_start") {
                    return false;
                }

                // VE-10377: wrap-up must not auto-dial (fail-safe: do not dial).
                if (this.isBlockedFromDialOrReconnectDuringWrapUp()) {
                    return false;
                }

                // VE-8387: auto-served missed calls must show only — Dial / Return Call is explicit.
                if (this.missedCallFromCallScreen) {
                    if (typeof this.clearDialIntent === "function") {
                        this.clearDialIntent();
                    }
                    return false;
                }

                // Must have phone numbers
                if (!(this.availableDialPhoneNumbers?.length > 0)) {
                    return false;
                }

                // Call must be null
                if (this.call !== null) {
                    return false;
                }

                // Device must be ready
                if (!this.device || this.status !== "ready") {
                    return false;
                }

                // One-shot only after dial actually starts (VE-8387) — keep intent if startNextDial no-ops.
                const started = this.startNextDial();
                if (started && typeof this.clearDialIntent === "function") {
                    this.clearDialIntent();
                }
                return started === true;
            },
            handleVinLoginDecisionIfNeeded() {
                if (this.vinLoginDecisionPending !== true) {
                    return false;
                }

                this.onVinLoginDecisionRequired?.();
                return true;
            },
            createAgentForOnCall() {

                // VE-10377: do not re-mint Outgoing/Incoming for a call that already ended.
                if (this.isDisconnectedCall()) {
                    return;
                }

                // Init
                const options = {
                    call_id: (this.call?.id || 0),
                    campaign_customer_id: (this.currentCampaignCustomer?.campaign_customer_id || 0),
                    campaign_id: (this.currentCampaignCustomer?.campaign_id || 0),
                    conference_id: (this.call?.conference_id || 0),
                    immediately_move_to_status: null,
                    noticeable_id: (this.currentCampaignCustomer?.campaign_customer_id || 0),
                    noticeable_type: "campaign_customer",
                    organization_id: (this.currentCampaignCustomer?.organization_id || 0),
                    status_name: (this.isOutbound === true ? "Outgoing Call" : "Incoming Call"),
                    scheduled_communication_id: (this.pendingSavedPlaceCall?.scheduled_communication_id || 0),
                }

                this.createAgent(options);
            },
            createAgentForWrapUp(endedCall) {

                // VE-10380: attribute wrap up to the call that ended, not whatever call is current now.
                const wrapUpCall = endedCall?.id > 0 ? endedCall : this.call;

                // VE-10380: save-and-next get-next can assign the next customer before disconnect — skip stale wrap-up.
                if (this.shouldSkipWrapUpForGetNextAdvance(wrapUpCall?.id || 0)) {
                    return;
                }

                // Init
                const options = {
                    call_id: (wrapUpCall?.id || 0),
                    campaign_customer_id: (this.currentCampaignCustomer?.campaign_customer_id || 0),
                    campaign_id: (this.currentCampaignCustomer?.campaign_id || 0),
                    conference_id: (wrapUpCall?.conference_id || 0),
                    immediately_move_to_status: null,
                    noticeable_id: (this.currentCampaignCustomer?.campaign_customer_id || 0),
                    noticeable_type: "campaign_customer",
                    organization_id: (this.currentCampaignCustomer?.organization_id || 0),
                    status_name: (this.isOutbound === true ? OUTBOUND_WRAP_UP : INBOUND_WRAP_UP),
                    scheduled_communication_id: (this.pendingSavedPlaceCall?.scheduled_communication_id || 0),
                }

                this.createAgent(options);
            },
            teardownDeviceListeners() {
                if (!this.device) return;
                this.device.off('error', this.deviceErrorHandler);
                this.device.off('unregistered', this.deviceOfflineHandler);
                this.device.off('tokenWillExpire', this.deviceOfflineHandler);
                this.device.off('registered', this.deviceReadyHandler);
            },
            async destroyDevice() {
                if (!this.device) {
                    return;
                }

                this._stopStatMonitoring();
                this.teardownDeviceListeners();

                const device = this.device;
                this.device = null;

                try {
                    if (device.state === 'registered') {
                        await device.unregister();
                    }
                } catch (e) {
                    console.error("twilio device unregister failed during teardown", e);
                }

                try {
                    await device.destroy();
                } catch (e) {
                    console.error("twilio device destroy failed during teardown", e);
                }
            },
            deviceConnectHandler(device) {
                this.status = "busy";

                // Set back to false since we are no longer setting up phone call
                this.initializingPhoneCall = false;

                // Create agent
                this.createAgentForOnCall();
            },
            deviceDisconnectHandler() {
                console.log("deviceDisconnectHandler")
                this.status = "ready";

                // ensure sampling is stopped when device leaves busy state
                this._stopStatMonitoring();

                // Set back to null since call is over
                this.connection = null;
                this.connectAttempt = false;

                // Set to true so we render next buttons
                this.disconnectedPhoneCall = true;

                // Scope the dial/reconnect refusal to the call that actually ended
                this.disconnectedCallId = this.connectedCall?.id || this.call?.id || 0;

                this.complianceWarnings = [];

                // Create agent
                this.createAgentForWrapUp(this.connectedCall);

                // Consume the snapshot so a repeat teardown falls back to the current call
                this.connectedCall = null;
            },
            deviceErrorHandler(e) {
                console.error("twilio device error", e);
                this.status = "error";
                this.showSnackbar("error", this.connectFailureMessage(e));

                if (e?.code === 31204 || e?.code === 31205) {
                    this.generateCapabilityToken();
                }
            },
            deviceOfflineHandler() {
                this.status = "offline";

                // Device went offline - attempt to reinit if device needs to reconnect
                if (!this.componentDestroyed) {
                    this.generateCapabilityToken();
                }
            },
            deviceReadyHandler() {
                this.status = "ready";

                // For an inbound call, we need to connect device to call when device is ready
                if (!this.continueSaveAndDialNextIfApplicable()) {
                    this.connectDeviceToCall();
                }
            },
            endCall() {
                this.device?.disconnectAll();
                this.handleAgentCallDisconnect();
            },
            ensureOverflowHidden() {

                // HACK: HERE
                const htmlTag = document.getElementsByTagName('html')[0];

                if (!!htmlTag) {
                    // remove tags
                    htmlTag.classList.remove('overflow-y-hidden');
                    htmlTag.classList.remove('overflow-y-scroll');
                    htmlTag.classList.add('overflow-y-hidden');

                }

                return;
            },
            exitTransferDialog() {
                this.transferToExtension = null;
                this.transferType = null;
                this.transferDialog = false;
            },
            generateCapabilityToken() {
                if (!this.validIncomingPhoneNumber || this.componentDestroyed) {
                    return;
                }

                GenerateCapabilityToken(this.incomingPhoneNumber?.incoming_phone_number_id, {}).then((response) => {
                    if (this.componentDestroyed) {
                        return;
                    }

                    if (response?.Data?.token?.length > 0) {
                        this.agentSoftphone = response?.Data?.agent_softphone;
                        this.agentToken = response?.Data?.token;
                        !!this.device ? this.updateDeviceToken() : this.initDevice();
                        return;
                    }

                    this.status = "error";
                    this.showSnackbar("error", "Unable to initialize phone. Try refreshing the page.");
                }).catch((err) => {
                    console.error("generate capability token failed", err);
                    this.status = "error";
                    this.showSnackbar("error", "Unable to initialize phone. Check your connection and try again.");
                });
            },
            handleAgentCallDisconnect() {
                console.debug("handle agent disconnect 1")
                if (!this.validCall) {
                    return;
                }
                console.debug("handle agent disconnect 2")

                const options = {
                    isBarge: this.isBarge,
                    isListen: this.isListen,
                    isCoaching: this.isCoach,
                }
                // Place customer leg on hold
                HandleAgentCallDisconnect(this.call.id, options).then((response) => {
                    if (response?.Data?.Ok === true) {
                        // Call ended successfully
                    }
                });
                console.debug("handle agent disconnect 3")
            },
            handleCreateOutboundCallResponse(data, error) {

                // TODO: eventually need to alter call screen, but for now just set state so we don't connect and start a new call leg
                this.isNonBrowserDevice = data?.is_non_browser_device === true;
                if (this.isNonBrowserDevice) {
                    this.initializingPhoneCall = false;
                }

                // Set call still if applicable - it is possible to have a valid call record that errored
                if (data?.call?.id > 0) {
                    this.call = data.call;
                    this.conference = data.conference;
                    this.otherLegRecordEnabled = data.other_leg_record_enabled;
                    this.complianceWarnings = data?.compliance_warnings?.length > 0 ? data.compliance_warnings : [];
                }

                // Handle error if necessary
                if (this.callFailed) {
                    this.handleOutboundCallError(error);
                }
            },
            handleOutboundCallError(errorMessage) {

                // If it errored, we need to unfreeze the agent status push if necessary
                if (this.freezeAgentStatusPush) {
                    this.toggleFreezeAgentStatusPush();
                }

                // Render error for agent to see
                if (errorMessage?.length > 0) {
                    this.showSnackbar("error", errorMessage);
                }

                // Set back to false since we no longer are doing this
                this.initializingPhoneCall = false;

                // Move agent into wrap up
                this.createAgentForWrapUp(this.call);
            },
            holdCall() {
                if (this.onHold || !this.validCall || this.isRunningAction) {
                    return;
                }

                // Set to true so the user cannot submit multiple requests at once
                this.isRunningAction = true;

                // Place customer leg on hold
                HoldCall(this.call.id).then((response) => {
                    if (response?.Data?.Ok === true) {
                        this.onHold = true;

                        // Agent leg also gets put on mute
                        this.isMuted = true;
                    }

                    this.isRunningAction = false;
                });
            },
            holdUnholdCall() {
                return this.onHold ? this.unholdCall() : this.holdCall();
            },
            initDevice() {
                if (!this.agentToken) {
                    return;
                }

                // Init device options
                const deviceOptions = {
                    codecPreferences: [Call.Codec.Opus, Call.Codec.PCMU], // ['opus', 'pcmu'],
                    edge: this.resolvedTwilioVoiceEdge(),
                    logLevel: this.currentUser?.account?.twilio_log_level || 5,
                }

                // Init device
                this.device = new Device(this.agentToken, deviceOptions);

                // Setup
                this.setupDevice();
            },
            isBlockedFromDialOrReconnectDuringWrapUp() {
                // Local disconnect covers the window before Wrap Up status is pushed.
                if (this.isDisconnectedCall()) {
                    return true;
                }
                return this.isWrapUpBlockingDial === true;
            },
            isDisconnectedCall() {
                // Only refuse the call that actually ended — a new call id must be allowed through.
                return this.disconnectedCallId > 0 && this.disconnectedCallId === (this.call?.id || 0);
            },
            muteCall() {
                if (this.isMuted || !this.validCall || this.isRunningAction) {
                    return;
                }

                // Set to true so the user cannot submit multiple requests at once
                this.isRunningAction = true;

                // Mute agent leg
                MuteCall(this.call.id).then((response) => {
                    if (response?.Data?.Ok === true) {
                        this.isMuted = true;
                    }

                    this.isRunningAction = false;
                });
            },
            muteUnmuteCall() {
                if (this.onHold == true) {
                    return;
                }

                return this.isMuted ? this.unmuteCall() : this.muteCall();
            },
            onConferenceUpdate(response) {

                // Verify data
                const conference = response?.Data;
                if (!conference || !(conference?.id > 0)) {
                    return;
                }

                // Verify conference matches conference on device
                if (!this.conference || !(conference.id === this.conference?.id)) {
                    return;
                }

                // Set updates
                this.conference.recording_id = conference.recording_id;
            },
            openDialPad() {
                this.dialPadDialog = true;
            },
            openInstantVoicemailDialog() {
                this.instantVoicemailDialog = true;
            },
            openTransferDialog(destination, location, type, destinationID, toNumber, toExtension) {
                this.transferDestination = destination;
                this.transferDestinationID = destinationID;
                this.transferLocation = location;
                this.transferToExtension = toExtension || null;
                this.transferToNumber = toNumber;
                this.transferType = type;
                this.transferDialog = true;
            },
            pauseRecording() {
                if (!this.validRecordingID || this.isRunningAction) {
                    return;
                }

                // Set to true so the user cannot submit multiple requests at once
                this.isRunningAction = true;

                // Pause recording
                PauseRecording(this.recordingID).then((response) => {
                    if (response?.Data?.ok === true) {
                        this.isRecordingPaused = true;
                        this.showSnackbar("green", "Successfully paused call recording");
                    }

                    this.isRunningAction = false;
                });
            },
            pauseResumeRecording() {
                if (!this.validRecordingID || this.isRunningAction) {
                    return;
                }

                return this.isRecordingPaused === true ? this.resumeRecording() : this.pauseRecording();
            },
            phoneAllowed(cpn) {

                // Verify
                if (!cpn || !(cpn.customer_phone_number_id > 0)) {
                    return false;
                }

                return (cpn.do_not_call === false && cpn.phone_number_do_not_call === false && cpn.has_account_or_organization_opt_out_phone === false && cpn.phone_number_is_litigator === false);
            },
            resumeRecording() {
                if (!this.validRecordingID || this.isRunningAction) {
                    return;
                }

                // Set to true so the user cannot submit multiple requests at once
                this.isRunningAction = true;

                // Pause recording
                ResumeRecording(this.recordingID).then((response) => {
                    if (response?.Data?.ok === true) {
                        this.isRecordingPaused = false;
                        this.showSnackbar("green", "Successfully resumed call recording");
                    }

                    this.isRunningAction = false;
                });
            },
            resolvedTwilioVoiceEdge() {
                return getTwilioVoiceEdge(this.currentUser?.account?.voice_edge ?? null);
            },
            sendDigit(digit, isTransfer) {

                // Verify digit
                if (!(digit?.length > 0)) {
                    return;
                }

                // Verify connection, device and call
                if (!this.validConnection || !this.validDevice || !this.validCall || !this.renderPhoneControls) {
                    return;
                }

                // Send digit
                this.connection?.sendDigits(digit);

                // Record the digit on the call. The sdk already played the tone, so a failure here only
                // costs us the record and must not tell the agent their keypress did not go through.
                SendDTMF(this.call.id, {
                    digit: digit,
                    is_transfer: isTransfer || false,
                }).catch(() => {});
            },
            showSnackbar(color, text) {
                if (color?.length > 0 && text?.length > 0) {
                    this.snackbar.color = color;
                    this.snackbar.text = text;
                    this.snackbar.show = true;
                }
            },
            setupDevice() {

                if (!this.device) {
                    return;
                }

                // Init callback handlers
                this.device.on('error', this.deviceErrorHandler);
                this.device.on('unregistered', this.deviceOfflineHandler);
                this.device.on('tokenWillExpire', this.deviceOfflineHandler);
                this.device.on('registered', this.deviceReadyHandler);
                // 'registering' event available

                // Register
                this.device.register();
            },
            startNextDial(overrideCustomerPhoneNumberId, overrideReturnVoiceMailRecordingID, overrideScheduledCommunicationID, forceOutboundNumber) {
                if (this.handleVinLoginDecisionIfNeeded()) {
                    return false;
                }

                // VE-10377: wrap-up must not start another Outgoing Call (fail-safe: do not dial).
                if (this.isBlockedFromDialOrReconnectDuringWrapUp()) {
                    return false;
                }

                // Verify we have a valid cc or an overriding from number (missed call use case)
                if ((!this.validCurrentCampaignCustomer || (!this.nextAttemptableID && !overrideCustomerPhoneNumberId)) && !(overrideReturnVoiceMailRecordingID > 0) && !(overrideScheduledCommunicationID > 0) && !(forceOutboundNumber?.length > 0)) {
                    return false;
                }

                // If we already have a valid call or are initializing, abort
                if (!!this.call || this.initializingPhoneCall === true) {
                    return false;
                }

                // Set
                this.initializingPhoneCall = true;
                this.isOutbound = true;
                this.complianceWarnings = [];

                const options = {
                    account_id: (this.currentCampaignCustomer.account_id || 0),
                    attempt_key: this.currentAgent?.attempt_key,
                    campaign_customer_active_id: (this.currentCampaignCustomer.campaign_customer_active_id || 0),
                    force_outbound_number: forceOutboundNumber,
                    force_outbound_campaign_id: this.currentCampaignCustomer?.campaign_id || 0,
                    incoming_phone_number_id: (this.incomingPhoneNumber?.incoming_phone_number_id || 0),
                    is_manual_call: this.isManualMode,
                    override_customer_phone_number_id: (overrideCustomerPhoneNumberId || 0),
                    override_return_voice_mail_recording_id: (overrideReturnVoiceMailRecordingID || 0),
                    override_scheduled_communication_id: (overrideScheduledCommunicationID || 0),
                    // Only a returned voicemail names a source from the comm center, whether clicked or served by get next
                    source_id: (overrideReturnVoiceMailRecordingID || this.voiceMailRecording?.voice_mail_recording_id || 0),
                    source_type: ((overrideReturnVoiceMailRecordingID || this.voiceMailRecording?.voice_mail_recording_id) > 0 ? "voice_mail_recording" : ""),
                }

                if (!this.freezeAgentStatusPush) {
                    this.toggleFreezeAgentStatusPush(); // set free to true so we don't push the agent into available after they've already started the process of dialing out
                }

                // Create outbound call
                CreateOutboundCall(options).then((response) => {
                    // Init
                    let needDelay = true;

                    // If error, need to mark call as fialed so we can start process of not getting the agent stuck
                    if (response?.Error?.length > 0) {
                        this.setCallFailed(true);
                        needDelay = true;
                    }

                    // If delay needed, add next tick
                    if (needDelay) {
                        Vue.nextTick(() => {
                            this.handleCreateOutboundCallResponse(response?.Data, response?.Error);
                        });
                    } else {
                        this.handleCreateOutboundCallResponse(response?.Data, response?.Error);
                    }
                });
                return true;
            },
            toggleOnHold() {
                this.onHold = !this.onHold;
            },
            toggleIsMuted() {
                this.isMuted = !this.isMuted;
            },
            unholdCall() {
                if (!this.onHold || !this.validCall || this.isRunningAction) {
                    return;
                }

                // Set to true so the user cannot submit multiple requests at once
                this.isRunningAction = true;

                // Place customer leg on hold
                UnholdCall(this.call.id).then((response) => {
                    if (response?.Data?.Ok === true) {
                        this.onHold = false;

                        // Agent leg also gets taken off mute
                        this.isMuted = false;
                    }

                    this.isRunningAction = false;
                });
            },
            unmuteCall() {
                if (!this.isMuted || !this.validCall || this.isRunningAction) {
                    return;
                }

                // Set to true so the user cannot submit multiple requests at once
                this.isRunningAction = true;

                // Unmute agent leg
                UnmuteCall(this.call.id).then((response) => {
                    if (response?.Data?.Ok === true) {
                        this.isMuted = false;
                    }

                    this.isRunningAction = false;
                });
            },
            updateDeviceToken() {

                // Verify
                if (!this.agentToken || !this.device || this.device.state === 'destroyed') {
                    return;
                }

                // Update
                this.device.updateToken(this.agentToken);
            },

            // -------- NEW TELEMETRY (DATA COLLECTION DURING CALLS ~ SAMPLING)

            // Attach per-call handlers so we begin sampling only after media is accepted, and stop on disconnect. Keeps things leak-free across many calls.
            _attachCallTelemetryHandlers(call: Call) {
                this._detachCallTelemetryHandlers();
                this._telemetryCallRef = call;

                this._onCallAcceptHandler = () => this._startQualitySampling(call);
                this._onCallDisconnectHandler = () => this._stopStatMonitoring();

                call.on('accept', this._onCallAcceptHandler);
                call.on('disconnect', this._onCallDisconnectHandler);
            },

            // Remove any bound call handlers
            _detachCallTelemetryHandlers() {
                if (this._telemetryCallRef) {
                    if (this._onCallAcceptHandler) {
                        this._telemetryCallRef.off('accept', this._onCallAcceptHandler);
                    }
                    if (this._onCallDisconnectHandler) {
                        this._telemetryCallRef.off('disconnect', this._onCallDisconnectHandler);
                    }
                }
                this._telemetryCallRef = null;
                this._onCallAcceptHandler = null;
                this._onCallDisconnectHandler = null;
            },

            // --- Install a hook so we can see PCs Twilio creates ---
            _ensurePcHook() {
                const w = window as any;
                if (w.__pcHookInstalled) return;

                const NativePC = w.RTCPeerConnection || w.webkitRTCPeerConnection;
                if (!NativePC) return;

                const live = new Set<RTCPeerConnection>();

                function WrappedPC(this: any, ...args: any[]) {
                    const pc = new (NativePC as any)(...args);
                    live.add(pc);

                    const cleanup = () => live.delete(pc);
                    const origClose = pc.close.bind(pc);
                    pc.close = () => { try { cleanup(); } catch {} ; try { origClose(); } catch {} };

                    pc.addEventListener?.('connectionstatechange', () => {
                        if (pc.connectionState === 'closed' || pc.connectionState === 'failed') cleanup();
                    });

                    // expose live set for lookups
                    (w.RTCPeerConnection as any).__liveSet = live;
                    return pc;
                }

                WrappedPC.prototype = NativePC.prototype;
                w.RTCPeerConnection = WrappedPC as any;
                (w.RTCPeerConnection as any).__native = NativePC;
                w.__pcHookInstalled = true;
            },

            // Choose the most likely PC that carries audio
            _getActivePc(): RTCPeerConnection | null {
                const PC: any = (window as any).RTCPeerConnection;
                const live: Set<RTCPeerConnection> | undefined = PC?.__liveSet;
                if (!live || live.size === 0) return null;

                // prune obviously closed items
                for (const pc of Array.from(live)) {
                    const cs = (pc as any).connectionState || (pc as any).iceConnectionState;
                    if (cs === 'closed' || cs === 'failed') live.delete(pc);
                }

                let fallback: RTCPeerConnection | null = null;
                for (const pc of live) {
                    const hasAudio =
                        (pc.getSenders?.() || []).some(s => s.track?.kind === 'audio') ||
                        (pc.getReceivers?.() || []).some(r => r.track?.kind === 'audio');
                    if (!hasAudio) continue;

                    const cs = (pc as any).connectionState || (pc as any).iceConnectionState;
                    if (cs === 'connected' || cs === 'completed') return pc;
                    if (!fallback) fallback = pc; // audio present but maybe still connecting
                }
                return fallback;
            },

            // Resolve ICE details from the current stats report.
            // Tries: transport.selectedCandidatePairId -> candidate-pair (selected/nominated) -> falls back to pair fields.
            // Returns local/remote candidate types and transport protocol.
            _extractIce(stats: RTCStatsReport, preselectedPair?: any) {
                // Prefer already-found pair if provided
                let pair: any = preselectedPair ?? null;

                if (!pair) {
                    // Look up via transport.selectedCandidatePairId
                    for (const r of stats.values()) {
                        if (r.type === 'transport' && (r as any).selectedCandidatePairId) {
                            const maybe = stats.get((r as any).selectedCandidatePairId as string);
                            if (maybe) { pair = maybe as any; break; }
                        }
                    }
                }

                if (!pair) {
                    // Fallback: any selected/nominated candidate-pair
                    for (const r of stats.values()) {
                        if (r.type === 'candidate-pair' && ((r as any).selected || (r as any).nominated)) {
                            pair = r as any; break;
                        }
                    }
                }

                if (!pair) {
                    return { localType: null, remoteType: null, protocol: null };
                }

                // Try to resolve full candidate objects for richer details
                let local: any = null, remote: any = null;
                if (pair.localCandidateId)  local  = stats.get(pair.localCandidateId as string) as any;
                if (pair.remoteCandidateId) remote = stats.get(pair.remoteCandidateId as string) as any;

                // Candidate types: prefer full candidate objects, then pair summaries
                const localType  = local?.candidateType  ?? pair.localCandidateType  ?? null;
                const remoteType = remote?.candidateType ?? pair.remoteCandidateType ?? null;

                // Protocol can appear on the local candidate or on the pair (implementation-specific)
                const proto = (local?.protocol || pair.candidateTransport || pair.transport || '').toString().toLowerCase() || null;

                return { localType, remoteType, protocol: proto };
            },

            // Begin listening to Twilio's 1 Hz "sample" event and ship compact stats
            _startQualitySampling(call: Call) {

                // reset to be safe
                this._stopQualitySampling();

                // ensure we have it enabled
                if (!this.isSamplingEnabled) {
                    return;
                }

                // state for deltas & timers
                let retryId: number = 0;
                let pollId: number = 0;
                let pc: RTCPeerConnection | null = null;
                let lastTs = 0;
                let lastRx = 0;
                let lastTx = 0;

                const ms = (n: number | undefined) => (typeof n === 'number' ? Math.round(n) : null);

                const find = (stats: RTCStatsReport, type: string, media: 'audio') => {
                    for (const r of stats.values()) {
                    // Chrome: r.kind === 'audio'; FF/Safari: r.mediaType === 'audio'
                        if (r.type === type && ((r as any).kind === media || (r as any).mediaType === media)) return r as any;
                    }
                    return null;
                };

                const findPair = (stats: RTCStatsReport) => {
                    // Prefer selected pair via transport; fallback to selected/nominated candidate-pair
                    for (const r of stats.values()) {
                        if (r.type === 'transport' && (r as any).selectedCandidatePairId) {
                            const pair = stats.get((r as any).selectedCandidatePairId as string);
                            if (pair) return pair as any;
                        }
                    }
                    for (const r of stats.values()) {
                        if (r.type === 'candidate-pair' && ((r as any).selected || (r as any).nominated)) {
                            return r as any;
                        }
                    }
                    return null;
                };

                const tick = async () => {
                    try {
                        if (!pc) pc = this._getActivePc();
                        if (!pc) return; // still not ready; retry will continue

                        const stats = await pc.getStats();
                        const inbound  = find(stats, 'inbound-rtp', 'audio');
                        const outbound = find(stats, 'outbound-rtp', 'audio');
                        const remoteIn = find(stats, 'remote-inbound-rtp', 'audio'); // for RTT if present
                        const pair     = findPair(stats);

                        // Timestamps for bitrate deltas
                        const now = (inbound?.timestamp ?? outbound?.timestamp ?? performance.now()) as number;
                        const dt = lastTs ? Math.max(1, (now - lastTs)) / 1000 : 0;

                        // Down / Up bitrate (kbps) via byte deltas
                        let downKbps: number | null = null;
                        let upKbps: number | null = null;

                        const rx = inbound?.bytesReceived ?? lastRx;
                        const tx = outbound?.bytesSent ?? lastTx;
                        if (dt > 0) {
                            if (inbound?.bytesReceived != null) downKbps = Math.max(0, Math.round(((rx - lastRx) * 8) / 1000 / dt));
                            if (outbound?.bytesSent  != null)   upKbps   = Math.max(0, Math.round(((tx - lastTx) * 8) / 1000 / dt));
                        }
                        lastTs = now;
                        lastRx = rx;
                        lastTx = tx;

                        // RTT: prefer remote-inbound-rtp.roundTripTime (s), else candidate-pair currentRoundTripTime (s)
                        const rttMs =
                        (typeof remoteIn?.roundTripTime === 'number' ? Math.round(remoteIn.roundTripTime * 1000) : null) ??
                        (typeof pair?.currentRoundTripTime === 'number' ? Math.round(pair.currentRoundTripTime * 1000) : null);

                        // Jitter: inbound.jitter (s) or compute from jitterBufferDelay/Count
                        const jitterMs =
                        typeof inbound?.jitter === 'number' ? Math.round(inbound.jitter * 1000)
                        : (typeof inbound?.jitterBufferDelay === 'number' &&
                        typeof inbound?.jitterBufferEmittedCount === 'number' &&
                        inbound.jitterBufferEmittedCount > 0)
                        ? Math.round((inbound.jitterBufferDelay / inbound.jitterBufferEmittedCount) * 1000)
                        : null;

                        // ICE candidate types & protocol (best-effort)
                        const ice = this._extractIce(stats, pair);

                        const out = {
                            timestamp: (new Date()).toISOString(), // utc
                            callId: this.call?.id ?? null,

                            // round-trip time (audio ↔ media server) in milliseconds. ~20–80 ms is typical;
                            rttMs,

                            // variation in packet arrival. <5–10 ms is good; 1 ms is excellent
                            jitterMs,

                            // cumulative inbound packet loss at the time of sampling. Zero is perfect
                            packetsLostDown: (typeof inbound?.packetsLost === 'number' ? inbound.packetsLost : null),
                            
                            // your encoded audio going up vs. coming down, in kbps. Opus voice often sits anywhere from ~12–40 kbps depending on frame size / silence / comfort-noise. These are normal
                            bitrateUpKbps: upKbps,
                            bitrateDownKbps: downKbps,

                            ice,
                            codec: (call as any)?.codec || 'opus',
                            conceal: {
                                // samples the jitter buffer filled in (PLC/concealment).
                                totalConcealedSamples: typeof inbound?.concealedSamples === 'number' ? inbound.concealedSamples : null,

                                // frames recovered via Opus FEC. These counters rise over time; small growth is normal. You judge them by rate (per second) alongside jitter/loss. With jitter=1 ms and loss=0 at this moment, you’re fine.
                                fecRecovered: typeof inbound?.fecPacketsReceived === 'number' ? inbound.fecPacketsReceived : null,
                            },

                             // peer connection
                            pcState: {
                                connection: pc.connectionState,
                                ice: pc.iceConnectionState,
                                signaling: pc.signalingState,
                            },

                            browserName: getBrowserInfo().name || '',
                            browserVersion: getBrowserInfo().version || '',
                            isTabHidden: document.hidden,
                        };

                        // post to service
                        CreateWebRtcSample(out);

                    } catch (err) {
                        // ignore transient errors; stats can briefly fail during ICE restarts
                        // console.debug('[rtc] tick error', err);
                    }
                };

                const tryStart = () => {
                    pc = this._getActivePc();
                    if (!pc) {
                        this._retryPollID = setTimeout(tryStart, 300);
                        return;
                    }
                    // first tick immediately, then 1 Hz
                    tick();
                    this._samplingPollID = setInterval(tick, this.webRtcSampleMs);
                };

                tryStart();
            },

            // Stop listening and clear handler
            _stopQualitySampling() {
                if (this._retryPollID) {
                    clearTimeout(this._retryPollID);
                    this._retryPollID = null;   
                }
                if (this._samplingPollID) {
                    clearInterval(this._samplingPollID);
                    this._samplingPollID = null;
                }
            },

            // conv function to stop sampling
            _stopStatMonitoring() {
                this._stopQualitySampling();
                this._detachCallTelemetryHandlers();
            },

        },
        computed: {
            accountPhoneSaveNext() {
                return this.currentUser?.account?.phone_save_next;
            },
            accountPhoneSaveStop() {
                return this.currentUser?.account?.phone_save_stop;
            },
            allowedExternalBlindTransfersEnabled() {
                return this.currentUser?.account?.enabled_transfers?.includes("external_blind_transfer");
            },
            allowedExternalWarmTransfersEnabled() {
                return this.currentUser?.account?.enabled_transfers?.includes("external_warm_transfer");
            },
            allowedInternalBlindTransfersEnabled() {
                return this.currentUser?.account?.enabled_transfers?.includes("internal_blind_transfer");
            },
            callId() {
                return this.call?.id;
            },
            currentAgent() {
                return VolieState.currentAgent();
            },
            currentUser() {
                return VolieState.currentUser();
            },
            instantVoiceMailEnabled() {
                if (this.isSupervisor) {
                    return false;
                }

                return this.currentUser?.account?.instant_voice_mail_enabled === true && this.isOutbound;
            },
            webRtcSampleMs() {
                return this.currentUser?.account_user?.web_rtc_sample_ms >= 1000 ? this.currentUser?.account_user?.web_rtc_sample_ms : null;
            },
            isSamplingEnabled() {
                return this.webRtcSampleMs > 0;
            },
            isStartNextDialButtonDisabled() {
                if (this.isSupervisor || this.isLiveDashInboundCall) {
                    return true;
                }

                return this.status !== "ready" || this.call?.id > 0 || !this.validAvailableDialPhoneNumbers;
            },
            isSupervisor() {
                return this.isBarge || this.isListen
            },
            holdBtnColor() {
                return this.onHold ? "var(--lt-red)" : "";
            },
            muteBtnColor() {
                return this.isMuted && !this.onHold ? "var(--lt-red)" : "";
            },
            nextAttemptableID() {
                return this.validCurrentCampaignCustomer && this.currentCampaignCustomer.next_attemptable_id > 0 && this.currentCampaignCustomer.next_attemptable_type === "customer_phone_number" ? this.currentCampaignCustomer.next_attemptable_id : null;
            },
            recordEnabled() {
                return this.validCall && (this.call?.record_enabled === true || this.otherLegRecordEnabled === true) && this.currentUser?.account?.recording_pause_enabled;
            },
            recordingID() {
                return this.conference?.id > 0 && this.conference?.recording_id > 0 ? this.conference?.recording_id : null;
            },
            renderManualMode() {
                return !this.validVoiceMailRecording && !this.validPausedVoiceMailRecording;
            },
            renderNextActions() {
                if (this.isSupervisor || this.isLiveDashInboundCall) {
                    return false;
                }

                return (this.status !== "busy" && this.disconnectedPhoneCall && this.call?.id > 0) || this.callFailed === true;
            },
            renderPhoneControls() {
                return this.isNonBrowserDevice ? false : (!this.initializingPhoneCall && this.status === "busy" && this.call?.id > 0);
            },
            renderSaveContinueButton() {
                return this.isManualMode || this.accountPhoneSaveNext === "continue" || (this.validVoiceMailRecording && !this.missedCallFromCallScreen) || this.validPausedVoiceMailRecording;
            },
            renderSaveStopButton() {
                return !this.isManualMode && (!this.validVoiceMailRecording || this.missedCallFromCallScreen) && !this.validPausedVoiceMailRecording;
            },
            renderStartActions() {
                return (this.initializingPhoneCall || !this.call) && !this.callFailed;
            },
            saveAndStopAction() {
                return this.accountPhoneSaveStop === "continue" ? "continue" : "stop";
            },
            selectedDispositionHasSmsMessageFollowUp() {
                return this.selectedCampaignDisposition?.campaign_disposition_id > 0 && this.selectedCampaignDisposition?.has_sms_message_follow_up === true;
            },
            showTransferMenu() {
                return this.allowedInternalBlindTransfersEnabled || this.allowedExternalBlindTransfersEnabled || this.allowedExternalWarmTransfersEnabled;
            },
            validAvailableDialPhoneNumbers() {
                return this.availableDialPhoneNumbers?.length > 0;
            },
            validCall() {
                return this.call?.id > 0;
            },
            validConnection() {
                return !!this.connection;
            },
            validCurrentCampaignCustomer() {
                return this.currentCampaignCustomer?.campaign_customer_active_id > 0;
            },
            validDevice() {
                return !!this.device;
            },
            validIncomingPhoneNumber() {
                return this.incomingPhoneNumber?.incoming_phone_number_id > 0;
            },
            validPausedVoiceMailRecording() {
                return this.isPausedVoiceMailRecording === true;
            },
            validRecordingID() {
                return this.recordingID > 0;
            },
            validVoiceMailRecording() {
                return this.voiceMailRecording?.voice_mail_recording_id > 0;
            },
            validPendingSavedPlaceCall() {
                return this.pendingSavedPlaceCall?.scheduled_communication_id > 0;
            },
        },
        components: {
            DialPad,
            InstantVoicemailDialog,
            ManualMode,
            TransferDialog,
        },
        props: {
            callFailed: Boolean,
            communicationManager: Object,
            completeAttemptForInternalTransfer: Function,
            createAgent: Function,
            currentCampaignCustomer: Object,
            enterManualMode: Function,
            exitManualMode: Function,
            forceCall: Object,
            forceConference: Object,
            forceEndCall: Boolean,
            forceStartNextDial: Boolean,
            forceTransferDialog: Object,
            forceIsNonBrowserDevice: Boolean,
            hasLoggedInQueues: Boolean,
            onVinLoginDecisionRequired: Function,
            incomingPhoneNumber: Object,
            isBarge: Boolean,
            isListen: Boolean,
            isLiveDashInboundCall: Boolean,
            isManualMode: Boolean,
            isOkayToSaveAndNext: Boolean,
            isPausedVoiceMailRecording: Boolean,
            isWrapUpBlockingDial: Boolean,
            missedCallFromCallScreen: Boolean,
            organizationUsers: Array,
            pendingSavedPlaceCall: Object,
            removeForceTransferDialog: Function,
            retryDialIntentToken: Number,
            saveAndNextAction: String,
            clearDialIntent: Function,
            selectedCampaignDisposition: Object,
            setCall: Function,
            setCallFailed: Function,
            setOnCall: Function,
            shouldSkipWrapUpForGetNextAdvance: Function,
            startSaveAndNext: Function,
            voiceMailRecording: Object,
            toggleFreezeAgentStatusPush: Function,
            freezeAgentStatusPush: Boolean,
            forceValidatedOutboundNumber: String,
            vinLoginDecisionPending: Boolean,
        },
        watch: {
            complianceWarnings(warnings) {
                this.clearComplianceSnackbarTimeout();
                this.complianceSnackbarShow = warnings.length > 0;
                if (warnings.length > 0) {
                    this.complianceSnackbarTimeoutId = setTimeout(() => {
                        this.complianceSnackbarTimeoutId = null;
                        this.complianceSnackbarShow = false;
                    }, 10000);
                }
            },
            call: {
                deep: true,
                handler() {
                    this.connectDeviceToCall();
                    this.setCall(this.call);

                    if (this.call?.direction === "outbound") {
                        this.isOutbound = true;
                    }
                },
            },
            communicationManager() {
                this.buildAvailableDialPhoneNumbers();
            },
            "communicationManager.customer_phone_numbers": {
                deep: true,
                handler() {
                    this.buildAvailableDialPhoneNumbers();
                },
            },
            "device.isBusy": {
                handler() {

                    // Verify valid connection
                    if (!this.connectAttempt) {
                        return;
                    }

                    console.log("device.isBusy watcher")
                    console.log("device.isBusy", this.device?.isBusy)

                    return this.device?.isBusy ? this.deviceConnectHandler() : this.deviceDisconnectHandler();
                },
            },
            forceCall: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.forceCall?.id > 0 && !this.call) {
                        this.call = { ...this.forceCall };
                    }

                    if (this.call?.direction === "outbound") {
                        this.isOutbound = true;
                    }

                    if (this.isListen) {
                        this.isMuted = true;
                    }
                },
            },
            forceConference: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.forceConference?.id > 0 && !this.conference) {
                        this.conference = { ...this.forceConference };
                    }
                },
            },
            forceEndCall: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.forceEndCall === true) {
                        this.endCall();
                    }
                },
            },
            forceIsNonBrowserDevice: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.forceIsNonBrowserDevice !== this.isNonBrowserDevice) {
                        this.isNonBrowserDevice = this.forceIsNonBrowserDevice;
                    }
                },
            },
            forceStartNextDial: {
                deep: true,
                immediate: true,
                handler() {
                    this.continueForceStartNextDialIfApplicable();
                },
            },
            forceTransferDialog: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.forceTransferDialog?.destination?.length > 0 && !this.transferDialog) {
                        this.openTransferDialog(
                            this.forceTransferDialog.destination,
                            this.forceTransferDialog.location,
                            this.forceTransferDialog.type,
                            this.forceTransferDialog.destinationId,
                            this.forceTransferDialog.toNumber,
                            this.forceTransferDialog.toExtension,
                        );
                        this.removeForceTransferDialog();
                    }
                },
            },
            // Disconnecting instance stays blocked while this.call is still the ended call; held dial
            // intent is redeemed by the device remounted after forceDestroy (get-next advance). Parent bumps
            // retryDialIntentToken only for dial-safe statuses after leaving wrap-up (VE-10377).
            retryDialIntentToken: {
                immediate: true,
                handler(token) {
                    if (!(token > 0)) {
                        return;
                    }
                    this.continueForceStartNextDialIfApplicable();
                    this.continueSaveAndDialNextIfApplicable();
                },
            },
            renderPhoneControls() {
                this.setOnCall(this.renderPhoneControls);

                // If we are no longer rendering the phone controls (no longer on call, close dialogs if applicable)
                if (!this.renderPhoneControls) {

                    // Dial pad
                    if (this.dialPadDialog) {
                        this.closeDialPad();
                    }

                    // Instant VM
                    if (this.instantVoicemailDialog) {
                        this.closeInstantVoicemail();
                    }

                    // Transfer
                    if (this.transferDialog) {
                        this.exitTransferDialog();
                    }
                }
            },
        },
        destroyed() {
            if (this.saveAndNextAction === "continue_and_start" || this.forceStartNextDial === true) {
                console.debug("device destroyed holding dial intent — retry depends on the remounted device");
            }
            this.clearComplianceSnackbarTimeout();
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "conferenceUpdate" }}, this.onConferenceUpdate);
            this.componentDestroyed = true;

            // stop sampling before tearing down the device
            this._stopStatMonitoring();

            // remove the window listener if we’re tearing down inside SPA
            if (this._onBeforeUnloadHandler) {
                window.removeEventListener('beforeunload', this._onBeforeUnloadHandler);
                this._onBeforeUnloadHandler = null;
            }

            // Destroy the device - terminates active and pending connections
            this.destroyDevice();
        },
        created() {
            if (this.isSamplingEnabled) {
                this._ensurePcHook();
            }
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "conferenceUpdate" }}, this.onConferenceUpdate);
            this.generateCapabilityToken();

            // try to flush final beacon on unload (best-effort)
            this._onBeforeUnloadHandler = () => { this._stopStatMonitoring(); };
            window.addEventListener('beforeunload', this._onBeforeUnloadHandler);
        },
    });
</script>

<style lang="scss" scoped>
    #app {
        .padding-xs {
            padding: 6px 0 6px 0;
        }

        .btn-margin-xs {
            margin: 4px 4px 4px 4px !important;
        }
    }
</style>
